module.exports = __webpack_public_path__ + "img/microphone.598e7996.svg";